const newsItemsFallback = [
  {
    id: 'fallback-mit-2019',
    title: 'Cracking Open the Black Box of Automated Machine Learning',
    publication: 'MIT News',
    date: 'May 31, 2019',
    link: '#',
  },
  {
    id: 'fallback-mit-2018',
    title: 'Reducing False Positives in Credit Card Fraud Detection',
    publication: 'MIT News',
    date: 'September 20, 2018',
    link: '#',
  },
  {
    id: 'fallback-fastco-2017',
    title: 'Most Creative People 2017: Kalyan Veeramachaneni',
    publication: 'Fast Company',
    date: 'May 31, 2017',
    link: '#',
  },
  {
    id: 'fallback-mit-2017-crowd',
    title: 'Crowdsourcing Big Data Analysis',
    publication: 'MIT News',
    date: 'October 30, 2017',
    link: '#',
  },
  {
    id: 'fallback-register-2017',
    title: 'MIT boffins hope to speed up analytics with GitHub-style platform',
    publication: 'The Register',
    date: 'February 3, 2017',
    link: '#',
  },
  {
    id: 'fallback-techrepublic-2017',
    title: 'Artificial data reduces privacy concerns and helps with big data analysis',
    publication: 'Fast Company',
    date: 'April 10, 2017',
    link: '#',
  },
  {
    id: 'fallback-huffpost-2017',
    title: 'How Synthetic Data Can Overcome Privacy Concerns',
    publication: 'The Huffington Post',
    date: 'March 14, 2017',
    link: '#',
  },
  {
    id: 'fallback-popmech-2017',
    title: 'Scientists Can Now Get Real Results from Fake Data',
    publication: 'Popular Mechanics',
    date: 'January 25, 2017',
    link: '#',
  },
  {
    id: 'fallback-wapo-2016',
    title: 'New MIT algorithm rubs shoulders with human intuition in big data analysis',
    publication: 'The Washington Post',
    date: 'October 5, 2016',
    link: '#',
  },
];

export default newsItemsFallback;
